export const SIDEBAR_PAGE_SIZE = 20;

export const OWNED_CONVERSATIONS_KEY = ["frontend-ownedConversations"] as const;

export const SHARED_CONVERSATIONS_KEY = ["sharedConversations"] as const;

export const SHARED_CONVERSATION_LOOKUP_ROOT = "sharedConversationLookup";

export const RECENT_CONVERSATIONS_KEY = [
    "frontend-recentConversations",
] as const;
